import {visibleAnalytics} from '../../utils/analytics'
import {DefaultBanner} from '../DefaultBanner/DefaultBanner'
import {Universe26Banner} from '../Universe26Banner/Universe26Banner'
import type {BannerDescriptor} from '../../marketing-global-banner.types'

export function GlobalBanner({banner}: {banner: BannerDescriptor}) {
  const {uid, mode, custom_design} = banner

  return (
    <global-banner
      id={uid}
      role="alert"
      aria-label="Announcement"
      data-color-mode={mode}
      data-light-theme="light"
      data-dark-theme="dark"
      data-analytics-visible={visibleAnalytics(uid)}
    >
      {custom_design === 'universe_26' ? <Universe26Banner banner={banner} /> : <DefaultBanner banner={banner} />}
    </global-banner>
  )
}
